import React, { lazy, Suspense } from "react";
import { Redirect } from "react-router-dom";

// Layout Types
import { defaultLayout, authLayout } from "./layouts";
import { componentPaths } from "./constants/path-constants";

// Route Views - Using lazy loading for code splitting
import DashboardComponent from "./containers/homePage/dashboard/dashboard.js";
import { LoginView } from "./containers/loginPage";
import LoginBySaltView from "./containers/loginPage/login-by-salt/login-by-salt";
import RegistrationView from "./containers/loginPage/registration/registration";
import CreatenewPasswordView from "./containers/loginPage/createnew-password";

// Lazy loaded components for better code splitting
const EstimatesListComponent = lazy(() => import("./containers/homePage/estimates-list/estimates-list.js"));
const OrderDetailsView = lazy(() => import("./containers/homePage/order-details/order-details"));
const OrderListView = lazy(() => import("./containers/homePage/order-list/order-list.js"));
const MissingArtListComponent = lazy(() => import("./containers/homePage/missing-art/missing-art-list/missing-art-list"));
const EProofListComponent = lazy(() => import("./containers/homePage/e-proof/e-proof-list/e-proof-list"));
const EProofDetailsComponent = lazy(() => import("./containers/homePage/e-proof/e-proof-detail/eProof-details"));
const PayBillsList = lazy(() => import("./containers/homePage/pay-bills/pay-bills-list/pay-bills-list"));
const StitchApprovalListComponent = lazy(() => import("./containers/homePage/stitch-approval/stitch-approval-list/stitch-approval-list"));
const preProductionApprovalList = lazy(() => import("./containers/homePage/pre-production-approval/pre-production-approval-list/pre-production-approval-list"));
const CheckInventoryListComponent = lazy(() => import("./containers/homePage/check-inventory/check-inventory-list.js"));
const ShipUpsEstimateListComponent = lazy(() => import("./containers/homePage/ship-ups-estimate-list/ship-ups-estimate-list"));
const UserActivationComponnet = lazy(() => import("./containers/loginPage/user-activation/user-activation"));
const UserRoleSupervisorsView = lazy(() => import("./containers/homePage/user-role-supervisors/user-role-supervisors"));
const CreateUser = lazy(() => import("./containers/homePage/roles-and-permissions/create-user"));
const ChangeRole = lazy(() => import("./containers/homePage/roles-and-permissions/change-role"));
const ManageSupervisor = lazy(() => import("./containers/homePage/roles-and-permissions/manage-supervisor"));

export const publicRoutes = [
  {
    path: "/",
    exact: true,
    layout: authLayout,
    component: () => <Redirect to={componentPaths.login} />,
  },
  {
    path: componentPaths.login_with_forgot_password,
    exact: true,
    layout: authLayout,
    component: LoginView,
  },
  {
    path: componentPaths.USER_ACTIVATION,
    layout: authLayout,
    component: UserActivationComponnet,
  },
  {
    path: componentPaths.registration,
    layout: authLayout,
    component: RegistrationView,
  },
  {
    path: componentPaths.login,
    // exact: true,
    layout: authLayout,
    component: LoginView,
  },
  {
    path: componentPaths.LOGIN_BY_SALT,
    // exact: true,
    layout: authLayout,
    component: LoginBySaltView,
  },
  {
    path: componentPaths.CREATE_RESET_PASSWORD,
    layout: authLayout,
    component: CreatenewPasswordView,
  },
];

export const privateRoutes = [
  {
    path: componentPaths.PRE_PRODUCTION_APPROVALS,
    layout: defaultLayout,
    component: preProductionApprovalList,
  },
  {
    path: componentPaths.STITCH_APPROVALS,
    layout: defaultLayout,
    component: StitchApprovalListComponent,
  },
  {
    path: componentPaths.missingarts,
    layout: defaultLayout,
    component: MissingArtListComponent,
  },
  {
    path: componentPaths.eproofs,
    layout: defaultLayout,
    component: EProofListComponent,
  },
  {
    path: componentPaths.eproofDetail,
    layout: defaultLayout,
    component: EProofDetailsComponent,
  },
  {
    path: componentPaths.estimates,
    layout: defaultLayout,
    component: EstimatesListComponent,
  },
  {
    path: componentPaths.paybills,
    layout: defaultLayout,
    component: PayBillsList,
  },
  {
    path: componentPaths.dashboard,
    layout: defaultLayout,
    component: DashboardComponent,
  },
  {
    path: componentPaths.orderlist,
    layout: defaultLayout,
    component: OrderListView,
  },
  {
    path: componentPaths.orderdetails(),
    layout: defaultLayout,
    component: OrderDetailsView,
  },
  {
    path: componentPaths.CHECK_INVENTORY,
    layout: defaultLayout,
    component: CheckInventoryListComponent,
  },
  {
    path: componentPaths.SHIP_UPS_ESTIMATE,
    layout: defaultLayout,
    component: ShipUpsEstimateListComponent,
  },
  // {
  //   path: componentPaths.USER_ROLE_ADMIN,
  //   layout: defaultLayout,
  //   component: UserRoleAdminView,
  // },
  {
    path: componentPaths.USER_ROLE_SUPERVISORS,
    layout: defaultLayout,
    component: UserRoleSupervisorsView,
  },

  {
    path: componentPaths.CHANGE_USER_ROLE,
    layout: defaultLayout,
    component: ChangeRole,
  },
  {
    path: componentPaths.CREATE_USER,
    layout: defaultLayout,
    component: CreateUser,
  },
  {
    path: componentPaths.MANAGE_SUPERVISIOR,
    layout: defaultLayout,
    component: ManageSupervisor,
  },
];
